import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';
import moment from 'moment-timezone';

export default class EventModel extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][Event][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/events`;
    }

    isOver() {
        return this.end_date && moment().isAfter(this.end_date);
    }

    hasChart() {
        return Boolean(this.chart);
    }

    isSeatedForRates() {
        // this method is here to simplify refactoring in the future
        // we have a problem where we need to show seated options in rates in specific moments
        // so this method will be called where necessary.
        // Once we have fixed the isSeated conundrum we can redirect this method to isSeated()
        // and delete isSeatedForRates slowly
        return this.is_seated || (this.chart && !this.use_sessions);
    }

    isSeated() {
        if (this.is_seated !== undefined) {
            return this.is_seated;
        }
        return this.chart;
    }

    isRealSeating() {
        return this.chart && this.is_seated;
    }

    isFakeSeating() {
        return this.chart && !this.is_seated && !this.use_sessions;
    }

    isFakeSeatingMultipleInventories() {
        return this.isFakeSeating() && this.inventories?.length > 1;
    }

    isFakeSeatingMultipleCategories(categories) {
        return this.isFakeSeating() && categories?.length > 1;
    }

    mustGenerateMinisite() {
        return !this.site && !this.gemino_url;
    }

    isPublicationScheduled() {
        if (this.publication_date === null) {
            return false;
        }

        return this.publication_status === 'draft';
    }

    isUseSessionsNoSeated() {
        return !this.is_seated && this.use_sessions;
    }

    isRealSeatingNoSessions() {
        return this.is_seated && !this.use_sessions;
    }

    isRealSeatingWithSessions() {
        return this.is_seated && this.use_sessions;
    }

    isPyvarOnly() {
        return this.pyvar_only;
    }

    get_status() {
        return this.isOver() && this.publication_status !== 'closed' ? 'over' : this.publication_status;
    }

    get_time_status() {
        if (this.publication_status === 'closed') {
            return 'finished';
        }

        switch (this.time_status) {
            case 'upcoming':
                return 'future';
            case 'over':
                return 'finished';
            case 'ongoing':
                return 'ongoing';
            default:
                return 'unknown';
        }
    }

    toOptions() {
        return {
            text: this.name,
            name: String(this.id),
            value: this.id,
            key: this.id
        };
    }
}
